import React from 'react';

import ConfirmationModal from '#/components/basic/modal/ConfirmationModal';
import { formatNumber } from '#/lib/display/formatting';
import { useSelector } from '#/reduxState/storeCore';

function OrderLinesRiskyUpdateModal({
  newPrice,
  onConfirm,
  onClose,
}: {
  newPrice: number;
  onConfirm: () => void;
  onClose: () => void;
}) {
  const currentMarket = useSelector(state => state.markets.currentMarket);
  const tickSizes = useSelector(state => state.markets.listedMarkets.tickSizes);
  return (
    <ConfirmationModal
      title="Note"
      onClose={onClose}
      onConfirm={onConfirm}
      processing={false}
      confirmText="Confirm"
    >
      The order may be filled immediately if you change the price to{' '}
      {formatNumber(newPrice, {
        fixedDecimals: currentMarket?.pair
          ? tickSizes[currentMarket.pair]?.visibleDecimals
          : undefined,
      })}
    </ConfirmationModal>
  );
}

export default OrderLinesRiskyUpdateModal;
